const TEXT = {
  confirm: "Are you sure? This will wipe the saved app and reload the newest version.",
  checking: "Checking connection…",
  offline: "No connection: hard reset needs internet. Try again when online.",
};

export default function HardResetDialog({ state, onCancel, onConfirm }) {
  const busy = state === "checking";
  return (
    <div className="reset-wrap hard-reset-wrap" data-testid="hard-reset-dialog" data-state={state} role="alertdialog" aria-modal="true">
      <div className="reset-box">
        <p className="reset-label">STAFF CONTROL · HARD RESET</p>
        <p className={`reset-text ${state === "offline" ? "is-bad" : ""}`} data-testid="hard-reset-dialog-text">{TEXT[state]}</p>
        <div className="reset-actions">
          <button type="button" className="reset-btn reset-cancel" data-testid="hard-reset-cancel-button" onClick={onCancel} disabled={busy}>
            {state === "offline" ? "OK" : "CANCEL"}
          </button>
          {state !== "offline" && (
            <button type="button" className="reset-btn reset-confirm" data-testid="hard-reset-confirm-button" onClick={onConfirm} disabled={busy}>
              HARD RESET
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
